import { AppDispatch } from "../store/store";
import { clearCredentials } from "../store/user-reducer";
import { setCookie } from "./utils";

export const signOut = (dispatch: AppDispatch) => {
    // Clear Redux state
    dispatch(clearCredentials());
    
    // Clear localStorage
    localStorage.clear();
    
    // Clear sessionStorage  
    sessionStorage.clear();
    
    // Clear demo account cookie
    setCookie('demo-account-created', '', -1); // Negative expiry to delete
    
    // Set a flag that user explicitly signed out
    setCookie('user-signed-out', 'true', 1); // Expires in 1 day
    
    // Redirect to home page
    window.location.href = '/';
};

export const safeGetCredentials = () => {
    try {
        const credentialsStr = localStorage.getItem('credentials');
        if (!credentialsStr) return null;
        return JSON.parse(credentialsStr);
    } catch (error) {
        console.error('Failed to parse credentials from localStorage, clearing corrupted data:', error);
        localStorage.removeItem('credentials');
        return null;
    }
};
